/* global slideDown */

// **************************************************
// Quiz
// **************************************************

const quiz = document.querySelector('.quiz__questions');

if (quiz) {
  const nextBtns = document.querySelectorAll('.quiz-question__next');
  const quizMain = document.querySelector('.quiz__main');

  setTimeout(() => {
    quizMain.classList.add('is-active');
    slideDown(quizMain, 500);
  }, 14000);

  // **************************************************

  // Open next question
  nextBtns.forEach((nextBtn) => {
    nextBtn.addEventListener('click', (event) => {
      const dataStep = event.target.closest('.quiz-question__next').getAttribute('data-step');
      const quizQuestion = document.querySelector(`.quiz-question.${dataStep}`);

      if (!quizQuestion.classList.contains('is-active')) {
        quizQuestion.classList.add('is-active');
        slideDown(quizQuestion, 300);
        const questionPosition = quizQuestion.offsetTop;
        setTimeout(() => {
          window.scrollTo(0, questionPosition);
        }, 200);
      }
    });
  });
}
